import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { isEmpty, size } from "lodash"

import { 
    ListItemText, 
    Checkbox, 
    MenuItem,
    Box,
    InputLabel,
    Select,
    OutlinedInput,
    Grid,
    FormControl,
    Button,
    InputAdornment,
    IconButton,
    Chip,
    TextField,
    Dialog as MuiDialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    DialogActions as MuiDialogActions,
    Paper,
    Typography,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

import Creatable from '../../common/Creatable';
import InputText, { InputSelectMultiV2, InputSelectNative, TextArea } from '../../common/Form';
import Dialog from '../../common/Dialog';
import ChantierFormPopUp from '../Chantiers/ChantierFormPopUp';
import EquipementPartPopUp from './EquipementPartPopUp';
import { AddCircleOutlineRounded, AddCircleRounded, AttachFileRounded, CloseRounded, DeleteRounded, DownloadRounded, InsertDriveFileRounded, PictureAsPdfRounded, VisibilityRounded } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import axios from 'axios';
import OtherActions from './OtherActions';
import { extension } from 'mime-types';
import { buildSinglePhotoUrl } from '../../../utils/photoFile';
import {
    getSpendingFiles as getSpendingFilesHelper,
    isPdfFile as isPdfFileHelper,
    isImageFile as isImageFileHelper,
    isInvalidPreviewBlobResponse,
} from '../../../utils/spendingAttachment';
import DeleteDialog from '../../common/DeleteDialog';

// Back-office admin allowlist for "Pièces justificatives" deletion (COMPTA-220).
// Mirrors the backend guard exactly — EXCLUDES USER_PLUS (10). Do not use role > 1.
const SPENDING_FILE_ADMIN_ROLES = [2, 3, 4];
const SPENDING_FILE_ACCEPT = "image/*,.pdf,.xls,.xlsx,.xlsm,.xlsb,.csv";

class SpendingsUpdate extends Component {
    previewAttachmentRequestId = 0;
    state = {
        isSubmitting: false,
        spending_desc : this.props.spending ? this.props.spending.spending_desc : "",
        spending_amount : this.props.spending ? this.props.spending.spending_amount : "",
        spending_amountTTC : this.props.spending ? this.props.spending.spending_amountTTC : "",
        spending_taxes : this.props.spending ? this.props.spending.spending_taxes : "",
        spending_taxes_debit : this.props.spending ? this.props.spending.spending_taxes_debit : "",
        spending_TVA : this.props.spending ? this.props.spending.spending_TVA : "",
        spending_date: this.props.spending ? this.props.spending.spending_date : new Date(),
        spending_category: this.props.spending ? this.props.spending.spending_category : "",
        spending_categoryDisplay: this.props.spending && this.props.spending.spending_category ? {
            value: this.props.spending.spending_category, 
            label: this.props.CATEGORIES.CHILD[this.props.spending.spending_category].category_accounting_id
                ? `${this.props.CATEGORIES.CHILD[this.props.spending.spending_category].category_accounting_id} - ${this.props.CATEGORIES.CHILD[this.props.spending.spending_category].category_name}`
                : this.props.CATEGORIES.CHILD[this.props.spending.spending_category].category_name
        } : {value:"", label:""},
        spending_status: this.props.spending ? this.props.spending.spending_status : "",
        spending_supplier: this.props.spending ? this.props.spending.spending_supplier : "",
        spending_supplierDisplay: this.props.spending && this.props.spending.spending_supplier ? {
            value: this.props.spending.spending_supplier, 
            label: this.props.SUPPLIERS[this.props.spending.spending_supplier].supplier_name
        } : {value:"", label:""},

        // spending_equipement: this.props.spending ? this.props.spending.spending_equipement : "",
        // spending_equipementDisplay: this.props.spending && this.props.spending.spending_equipement ? {
        //     value: this.props.spending.spending_equipement, 
        //     label: `${this.props.EQUIPEMENTS[this.props.spending.spending_equipement].equipement_ref.toUpperCase()} | ${this.props.EQUIPEMENTS[this.props.spending.spending_equipement].equipement_name}`
        // } : {value:"", label:""},
        // spending_vehicule: this.props.spending ? this.props.spending.spending_vehicule : "",
        // spending_vehiculeDisplay: this.props.spending && this.props.spending.spending_vehicule ? {
        //     value: this.props.spending.spending_vehicule, 
        //     label: `${this.props.VEHICULES[this.props.spending.spending_vehicule].equipement_ref.toUpperCase()} | ${this.props.VEHICULES[this.props.spending.spending_vehicule].equipement_name}`
        // } : {value:"", label:""},
        
        spending_labels: [],
        // spending_equipements: [],
        // spending_vehicules: [],
        spending_project: [],
        spending_labelsID: [],
        // spending_equipementsID: [],
        // spending_vehiculesID: [],
        spending_projectID: [],
        spending_chantier: (this.props.spending && this.props.spending.spending_chantier) ? this.props.spending.spending_chantier.split(", ") : [],
        spending_chantier_part:[],
        updatedChantier: false,
        spending_equipement: (this.props.spending && this.props.spending.spending_equipement) ? this.props.spending.spending_equipement.split(", ") : [],
        spending_equipement_part:[],
        updatedEquipement: false,
        spending_remarks: this.props.spending ? this.props.spending.spending_remarks : "",
        spending_demand: this.props.spending ? this.props.spending.spending_demand : null,

        open: false,
        previewAttachmentOpen: false,
        previewAttachment: null,
        previewAttachmentIndex: -1,
        previewAttachmentLoading: false,
        previewAttachmentNotFound: false,
        previewAttachmentObjectUrl: "",
        // Pièces justificatives (COMPTA-220) — dedicated SpendingFileEntity
        // records, distinct from the legacy spending_files preview grid above.
        attachmentFiles: [],
        attachmentFilesLoading: false,
        attachmentFilesError: null,
        uploadingAttachment: false,
        deleteAttachmentDialog: { open: false, file: null },
        deleteAttachmentError: null,
        deletingAttachment: false,
        errors:{
            spending_category: "",
            spending_supplier:"",
            spending_status: "",
            spending_project: "",
        },
    }
    componentDidMount = () => {
        const { LABELS, PROJECTS, spending } = this.props;

        // Charger les demandes de dépense si elles ne sont pas déjà chargées
        if (isEmpty(this.props.SPENDING_DEMANDS) && this.props.fetchAdminSpendingsDemand) {
            this.props.fetchAdminSpendingsDemand();
        }
        
        if( spending ){
            // this.fetchChantierInfo()
            this.fetchEquipementInfo()
            this.fetchAttachmentFiles()

            let labelsDisplay = []
            let projectsDisplay = []
            let labelsID = []
            let projectsID = []
            
            if(!isEmpty(spending.spending_labels)){
                labelsID = spending.spending_labels.split(", ")
                labelsID.map( label => {
                    labelsDisplay.push({
                        value: label,
                        label: LABELS[label].label_name,
                        disabled: false,
                    })
                })
            }
            if(!isEmpty(spending.spending_project)){
                projectsID = spending.spending_project.split(", ")
                projectsID.map( project => {
                    projectsDisplay.push({
                        value: project,
                        label: PROJECTS[project]?.project_name || 'NA',
                        disabled: false ,
                    })
                })
            }

            this.setState({
                spending_labels: labelsDisplay,
                spending_project: projectsDisplay,
                spending_labelsID: labelsID,
                spending_projectID: projectsID,
            })

        }
    }
    
    componentDidUpdate = (prevProps) => {
        // Si les SPENDING_DEMANDS viennent d'être chargés, forcer le re-render
        if (isEmpty(prevProps.SPENDING_DEMANDS) && !isEmpty(this.props.SPENDING_DEMANDS)) {
            this.forceUpdate();
        }
    }
    componentWillUnmount = () => {
        this.revokePreviewObjectUrl();
    }
    
    getSpendingDemandOptions = () => {
        const { SPENDING_DEMANDS } = this.props;

        if (!SPENDING_DEMANDS || isEmpty(SPENDING_DEMANDS)) {
            return [];
        }

        const ALLOWED_STATUSES = ["VALIDATE", "PAYED", "CREDITED"];
        const sortedDemands = Object.values(SPENDING_DEMANDS)
            .filter(d => ALLOWED_STATUSES.includes(d.spending_demand_status))
            .sort((a, b) => {
                const dateA = new Date(a.spending_demand_date || 0).getTime();
                const dateB = new Date(b.spending_demand_date || 0).getTime();
                return dateB - dateA;
            });
        return sortedDemands;
    }

    getSpendingDemandDisplay = (demand) => {
        if (!demand) return "";
        const date = demand.spending_demand_date
            ? new Date(demand.spending_demand_date).toLocaleDateString("fr-FR")
            : "";
        const title = demand.spending_demand_name || demand.spending_demand_desc || demand.spending_demand_reference || demand.spending_demand_id || "";
        const amount = demand.spending_demand_amount !== undefined && demand.spending_demand_amount !== null
            ? `${Number(demand.spending_demand_amount).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
            : "";
        const result = [date, title, amount].filter(Boolean).join(" - ");
        return result || ""; // S'assurer de toujours retourner une string
    }

    getSpendingDemandOptionById = (spendingDemandId, options = null) => {
        if (!spendingDemandId) return null;
        const list = options || this.getSpendingDemandOptions();
        return list.find(option => option.spending_demand_id === spendingDemandId) || null;
    }

    filterSpendingDemandOptions = (options, { inputValue }) => {
        const terms = inputValue
            ? inputValue.trim().toLowerCase().split(/\s+/).filter(Boolean)
            : [];

        if (!terms.length) {
            return options;
        }

        return options.filter(option => {
            const label = this.getSpendingDemandDisplay(option).toLowerCase();
            return terms.every(term => label.includes(term));
        });
    }

    handleChangeSpendingDemand = (event, newValue) => {
        this.setState({
            spending_demand: newValue ? newValue.spending_demand_id : null
        });
    }
    getSpendingFiles = () => {
        return getSpendingFilesHelper(this.props?.spending);
    }
    getSpendingFileUrl = (file) => {
        // Server-side attachments (COMPTA-220) carry an explicit binary-passthrough
        // URL (__serverUrl) instead of the legacy embedded `filename` used to
        // derive /photos/single/... URLs — prefer it when present.
        if (file && file.__serverUrl) return file.__serverUrl;
        return buildSinglePhotoUrl(file);
    }
    isPdfFile = (file) => isPdfFileHelper(file);
    isImageFile = (file) => isImageFileHelper(file);
    revokePreviewObjectUrl = () => {
        if (this.state.previewAttachmentObjectUrl) {
            URL.revokeObjectURL(this.state.previewAttachmentObjectUrl);
        }
    }
    openAttachmentPreview = async (file, index) => {
        if (!file || !file.filename) return;
        const fileUrl = this.getSpendingFileUrl(file);
        const canPreview = this.isPdfFile(file) || this.isImageFile(file);

        this.previewAttachmentRequestId += 1;
        const requestId = this.previewAttachmentRequestId;
        this.revokePreviewObjectUrl();

        this.setState({
            previewAttachmentOpen: true,
            previewAttachment: file,
            previewAttachmentIndex: index,
            previewAttachmentLoading: canPreview,
            previewAttachmentNotFound: !fileUrl,
            previewAttachmentObjectUrl: "",
        });

        if (!canPreview || !fileUrl) return;

        try {
            const res = await axios.get(fileUrl, { responseType: "blob" });
            if (requestId !== this.previewAttachmentRequestId) return;

            const contentType = `${res?.headers?.["content-type"] || res?.data?.type || ""}`;
            if (isInvalidPreviewBlobResponse(res?.data, contentType)) {
                this.setState({
                    previewAttachmentLoading: false,
                    previewAttachmentNotFound: true,
                });
                return;
            }

            const previewObjectUrl = URL.createObjectURL(res.data);
            this.setState({
                previewAttachmentLoading: false,
                previewAttachmentNotFound: false,
                previewAttachmentObjectUrl: previewObjectUrl,
            });
        } catch (error) {
            if (requestId !== this.previewAttachmentRequestId) return;
            this.setState({
                previewAttachmentLoading: false,
                previewAttachmentNotFound: true,
            });
        }
    }
    closeAttachmentPreview = () => {
        this.previewAttachmentRequestId += 1;
        this.revokePreviewObjectUrl();
        this.setState({
            previewAttachmentOpen: false,
            previewAttachment: null,
            previewAttachmentIndex: -1,
            previewAttachmentLoading: false,
            previewAttachmentNotFound: false,
            previewAttachmentObjectUrl: "",
        });
    }
    // ============================================================
    // Pièces justificatives (COMPTA-220) — dedicated SpendingFileEntity
    // records, distinct from the legacy spending_files preview grid above.
    // ============================================================
    fetchAttachmentFiles = async () => {
        const spendingId = this.props.spending && this.props.spending.spending_id;
        if (!spendingId) return;
        this.setState({ attachmentFilesLoading: true, attachmentFilesError: null });
        try {
            const res = await axios.get(`/spendings/${spendingId}/files`);
            const list = Array.isArray(res.data)
                ? res.data
                : (Array.isArray(res.data && res.data.data) ? res.data.data : []);
            this.setState({ attachmentFiles: list });
        } catch (err) {
            console.error("fetchAttachmentFiles error", err);
            this.setState({ attachmentFilesError: "Impossible de charger les pièces justificatives" });
        } finally {
            // Always clear the loading flag, success or failure, so the UI
            // never gets stuck showing a loading indicator indefinitely.
            this.setState({ attachmentFilesLoading: false });
        }
    }
    readAttachmentAsDataUri = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    })
    handleAddAttachmentFiles = async (e) => {
        const spendingId = this.props.spending && this.props.spending.spending_id;
        const files = Array.from(e.target.files || []);
        e.target.value = "";
        if (!spendingId || files.length === 0) return;

        this.setState({ uploadingAttachment: true, attachmentFilesError: null });
        try {
            for (const file of files) {
                const data_uri = await this.readAttachmentAsDataUri(file);
                await axios.post(`/spendings/${spendingId}/files`, {
                    filename: file.name,
                    data_uri,
                    filetype: file.type,
                });
            }
            await this.fetchAttachmentFiles();
        } catch (err) {
            console.error("handleAddAttachmentFiles error", err);
            this.setState({ attachmentFilesError: "Erreur lors de l'ajout d'une pièce justificative" });
        } finally {
            this.setState({ uploadingAttachment: false });
        }
    }
    openDeleteAttachmentDialog = (file) => {
        this.setState({ deleteAttachmentDialog: { open: true, file }, deleteAttachmentError: null });
    }
    closeDeleteAttachmentDialog = () => {
        if (this.state.deletingAttachment) return;
        this.setState({ deleteAttachmentDialog: { open: false, file: null }, deleteAttachmentError: null });
    }
    handleDeleteAttachmentSubmit = async (password) => {
        const spendingId = this.props.spending && this.props.spending.spending_id;
        const file = this.state.deleteAttachmentDialog.file;
        if (!spendingId || !file) return;

        this.setState({ deletingAttachment: true, deleteAttachmentError: null });
        try {
            // Password travels via header X-File-Delete-Password (pinned wire
            // contract) — never the query string, and validated by the Go backend.
            await axios.delete(`/spendings/${spendingId}/files/${file.spf_id}`, {
                headers: { "X-File-Delete-Password": password },
            });
            this.setState({ deleteAttachmentDialog: { open: false, file: null }, deletingAttachment: false });
            await this.fetchAttachmentFiles();
        } catch (err) {
            console.error("handleDeleteAttachmentSubmit error", err);
            const status = err && err.response && err.response.status;
            this.setState({
                deletingAttachment: false,
                deleteAttachmentError: (status === 401 || status === 403)
                    ? "Mot de Passe Incorrect"
                    : "Erreur lors de la suppression",
            });
        }
    }
    fetchChantierInfo = async () => {
        const res = await axios.post("/chantiers/spending/part/list", { data: this.props.spending.spending_id })
        console.log({res});
        if (!isEmpty(res)){
            this.setState({spending_chantier_part: res.data})
        }

    }
    fetchEquipementInfo = async () => {
        const res = await axios.post("/equipements/spending/part/list", { data: this.props.spending.spending_id })
        console.log({res});
        if (!isEmpty(res)){
            this.setState({spending_equipement_part: res.data})
        }

    }
    // FORM
    handleChange = (e) => {

        const name = e.target.name
        const value = e.target.value
        const regexF = /^[-+]?[0-9]*\.?[0-9]+$/ // accept negatives
        // const regexF = /^(?[0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "spending_amount" , "spending_amountTTC", "spending_taxes", "spending_taxes_debit",  "spending_TVA" ]

        if (!floatFields.includes(name) ){
            this.setState({
                [name]: value
            })
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            this.setState({
                [name]: value
            })
        }
    }

    handleChangeCat = (option) => {
        if(option){
            this.setState({
                spending_category: option.value || "",
                spending_categoryDisplay: option
            })
        } else {
            this.setState({
                spending_category: "",
                spending_categoryDisplay: {}
            })

        }
    }
    handleChangeSelect = (option, name) => {
        if(option){
            this.setState({
                [name]: option.value || "",
                [`${name}Display`]: option
            })
        } else {
            this.setState({
                [name]: "",
                [`${name}Display`]: {}
            })

        }
    }
    handleChangeMulti = (option, field) => {
        console.log('====================================');
        console.log({option, field});
        console.log('====================================');
        if(option){
            let IDList = option.map( item => item.value)
            this.setState({                
                [field]: option,
                [`${field}ID`]: IDList,
                page: 0,
                // checkedItems :[]
            })
        } else {
            this.setState({
                [field]: {label: "", value: ""},
                [`${field}ID`]: [],
                page: 0,
                // checkedItems :[]
            })

        }
    }
    
    setChantier = (boxIDList, infoList) => {
        
        this.setState({
            spending_chantier: boxIDList,
            spending_chantier_part: infoList,
            openChantierPopUp: false,
            updatedChantier: true
        })
        
    }
    setEquipement = (equipement_idList, infoList) => {
        
        this.setState({
            spending_equipement: equipement_idList,
            spending_equipement_part: infoList,
            openOther: false,
            // openEquipPopUp: false,
            updatedEquip: true
        })
        
    }
    handleDeleteChip = (index) => {
        let cpList = [].concat(this.state.spending_chantier_part)
        cpList = [
            ...cpList.slice(0,index),
            ...cpList.slice(index +1),
        ]
        
        this.setState({
            spending_chantier_part: cpList,
            updatedChantier: true
        })   
    }
    handleDeleteChipE = (index) => {
        let cpList = [].concat(this.state.spending_equipement_part)
        cpList = [
            ...cpList.slice(0,index),
            ...cpList.slice(index +1),
        ]
        
        this.setState({
            spending_equipement_part: cpList,
            updatedEquipement: true
        })   
    }
    validate = () => {
        let required = [
            // "spending_category",
            "spending_status",
            // "spending_project",
        ]
      //  this.state.spending_status !== "VALIDATE" && required.push("spending_remarks")
        this.state.spending_status === "VALIDATE" && required.push("spending_supplier", "spending_category")
        
        let noError = true
        let errors = {}
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        if (this.state.spending_amountTTC != this.state.spending_amount) {
           let sTotal = parseFloat(this.state.spending_amount) + parseFloat(this.state.spending_TVA) + parseFloat(this.state.spending_taxes_debit )- parseFloat(this.state.spending_taxes)
           if (this.state.spending_amountTTC !== sTotal ){
                let diff = parseFloat(this.state.spending_amountTTC) - sTotal
                noError =  false
                errors["spending_amountTTC"] = `Le montant ne correspond (différence de ${diff})`
            } else {
                errors["spending_amountTTC"] = "" 
            }
           
        }
        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = this.props.spending
            data.spending_taxes = parseFloat(this.state.spending_taxes)
            data.spending_taxes_debit = parseFloat(this.state.spending_taxes_debit)
            data.spending_TVA = parseFloat(this.state.spending_TVA)
            data.spending_category = this.state.spending_category
            data.spending_update_date = new Date()
            data.spending_status = this.state.spending_status
            data.spending_supplier = this.state.spending_supplier
            data.spending_remarks =  this.state.spending_remarks
            data.spending_labels = isEmpty(this.state.spending_labels) ? "" : this.state.spending_labelsID.join(", ")
            data.spending_project = isEmpty(this.state.spending_project) ? "" : this.state.spending_projectID.join(", ")
            data.spending_chantier = this.state.updatedChantier ? "toUpdate" : (isEmpty(this.state.spending_chantier) ? "" : this.state.spending_chantier.join(", "))
            data.spending_chantier_part = this.state.spending_chantier_part
            data.spending_equipement = this.state.updatedEquip ? "toUpdate" : (isEmpty(this.state.spending_equipement) ? "" : this.state.spending_equipement.join(", "))
            data.spending_equipement_part = this.state.spending_equipement_part
            // Inclure spending_demand (doit être un ID string ou null)
            if (this.state.spending_demand) {
                data.spending_demand = typeof this.state.spending_demand === 'string' 
                    ? this.state.spending_demand 
                    : (this.state.spending_demand.spending_demand_id || this.state.spending_demand);
            } else {
                data.spending_demand = null;
            }
            
            this.setState({ isSubmitting: true })
            try {
                await this.props.updateSpending(data)
            } finally {
                this.setState({ isSubmitting: false })
            }

            // if NoErrors ...
            if(this.props.STATE.spendings.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.spendings.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        console.log("New spending PROPS", this.props);
        
        const { CATEGORIES, SUPPLIERS, LABELS, PROJECTS, SPENDING_DEMANDS } = this.props;
        const spendingDemandOptions = this.getSpendingDemandOptions();
        const isFetchingSpendingDemands = this.props.STATE?.spendingDemands?.fetching || false;
        const previewAttachmentUrl = this.state.previewAttachmentObjectUrl;
        const previewAttachmentDownloadUrl = this.getSpendingFileUrl(this.state.previewAttachment);
        const isFileAdmin = SPENDING_FILE_ADMIN_ROLES.includes(this.props.role);
        // Server-side attachments (COMPTA-220) are the single source of truth: the
        // embedded spending_files array is migrated into this collection, so
        // rendering it alongside would duplicate rows post-migration.
        const allAttachmentFiles = this.state.attachmentFiles.map((file) => ({
            filename: file.spf_file_name,
            filetype: file.spf_file_type,
            __serverUrl: `/spendings/files/${file.spf_file_id}`,
            __serverFile: file,
        }));

        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
       
        return (
            <Dialog
                close={this.props.handleClose}
                fullScreen
                appBar
                submitAction={this.handleSubmit}
                disabledSubmit={this.state.isSubmitting}
                title={"Compléter"}
            >
                {this.state.openChantierPopUp &&
                    <ChantierFormPopUp
                        handleClose={() => this.setState({ openChantierPopUp: false})}
                        setChantier={this.setChantier}
                        spending_amount={this.state.spending_amountTTC}
                        list={this.state.spending_chantier_part}
                        notif={this.props.notif}
                    />
                }
                {this.state.openOther &&
                    <EquipementPartPopUp
                        handleClose={() => this.setState({ openOther: false})}
                        setEquipement={this.setEquipement}
                        spending_amount={this.state.spending_amountTTC}
                        list={this.state.spending_equipement_part}
                        notif={this.props.notif}
                        EQUIPEMENTS={this.props.EQUIPEMENTS}
                        VEHICULES={this.props.VEHICULES}
                        fetchEquipements={this.props.fetchEquipements}
                        fetchVehicules={this.props.fetchVehicules}
                    />
                }
                {/* {this.state.openOther &&
                    <OtherActions
                        handleClose={() => this.setState({ openOther: false})}
                        // setChantier={this.setChantier}
                        // spending_amount={this.state.spending_amountTTC}
                        // list={this.state.spending_chantier_part}
                        notif={this.props.notif}
                        {...this.state}
                        EQUIPEMENTS={this.props.EQUIPEMENTS}
                        VEHICULES={this.props.VEHICULES}
                        fetchEquipements={this.props.fetchEquipements}
                        fetchVehicules={this.props.fetchVehicules}
                        handleChangeSelect={this.handleChangeSelect}
                    />
                } */}
                <Grid container spacing={3}>
                    <Grid container item xs={12} sm={6}>
                        <Grid item xs={12}>
                            <InputText
                                required
                                disabled
                                name="spending_date" 
                                id="spending_date" 
                                value={new Date(this.state.spending_date).toLocaleDateString("fr-FR")} 
                                label="Date de Paiement" 
                            />
                        </Grid>         
                        <Grid item xs={12}>
                            <InputText
                                required
                                disabled
                                name="spending_amount" 
                                id="spending_amount" 
                                value={this.state.spending_amount} 
                                label="Montant HT" 
                            />
                        </Grid>          
                        <Grid item xs={12}>
                            <InputText
                                required
                                disabled
                                name="spending_amountTTC" 
                                id="spending_amountTTC" 
                                value={this.state.spending_amountTTC} 
                                label="Montant TTC" 
                            />
                        </Grid>          
                    </Grid>
                    <Grid container item xs={12} sm={6}>
                        <Grid item xs={12}>
                            <TextArea
                                disabled
                                required
                                rows="10"
                                name="spending_desc" 
                                id="spending_desc" 
                                value={this.state.spending_desc} 
                                label="Description" 
                            />
                        </Grid>     
                    </Grid>
                    <Grid item xs={12}>
                        <Paper variant="outlined" style={{ padding: 12 }}>
                            <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                <Typography variant="subtitle2">
                                    Pièces justificatives
                                </Typography>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    component="label"
                                    startIcon={<AttachFileRounded />}
                                    disabled={this.state.uploadingAttachment}
                                >
                                    {this.state.uploadingAttachment ? "Ajout en cours..." : "Ajouter"}
                                    <input
                                        type="file"
                                        hidden
                                        multiple
                                        accept={SPENDING_FILE_ACCEPT}
                                        onChange={this.handleAddAttachmentFiles}
                                    />
                                </Button>
                            </Box>
                            {this.state.attachmentFilesLoading && (
                                <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: 8 }}>
                                    Chargement…
                                </Typography>
                            )}
                            {this.state.attachmentFilesError && (
                                <Typography variant="caption" color="error" style={{ display: "block", marginBottom: 8 }}>
                                    {this.state.attachmentFilesError}
                                </Typography>
                            )}
                            {isEmpty(this.state.attachmentFiles) && !this.state.attachmentFilesLoading && (
                                <Typography variant="body2" color="textSecondary">
                                    Aucune pièce jointe
                                </Typography>
                            )}
                            {allAttachmentFiles.map((file, index) => {
                                const isServerFile = !!file.__serverFile;
                                const isPdf = this.isPdfFile(file);
                                const isImage = this.isImageFile(file);
                                const hasFile = !!file?.filename;
                                const fileUrl = this.getSpendingFileUrl(file);
                                const downloadName = isServerFile
                                    ? (file.__serverFile.spf_file_name || `fichier${index + 1}`)
                                    : `fichier${index + 1}.${extension(file?.filetype || "") || "bin"}`;
                                return (
                                    <Box
                                        key={isServerFile ? file.__serverFile.spf_id : `${file?.filename || "spending-file"}-${index}`}
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        style={{ gap: 12, marginBottom: index === allAttachmentFiles.length - 1 ? 0 : 8 }}
                                    >
                                        <Box display="flex" alignItems="center" style={{ gap: 10, minWidth: 0 }}>
                                            <Box
                                                style={{
                                                    width: 56,
                                                    height: 56,
                                                    border: "1px solid #e0e0e0",
                                                    borderRadius: 4,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    overflow: "hidden",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                {isImage && hasFile && (
                                                    <img
                                                        src={fileUrl}
                                                        alt={`justificatif-${index + 1}`}
                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                    />
                                                )}
                                                {isPdf && <PictureAsPdfRounded color="error" />}
                                                {!isImage && !isPdf && <InsertDriveFileRounded color="action" />}
                                            </Box>
                                            <Box style={{ minWidth: 0 }}>
                                                <Typography variant="body2" noWrap>
                                                    {`Fichier ${index + 1}`}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary" noWrap>
                                                    {file?.filetype || "Type inconnu"}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box display="flex" alignItems="center" style={{ gap: 8, flexShrink: 0 }}>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                startIcon={<VisibilityRounded />}
                                                onClick={() => this.openAttachmentPreview(file, index)}
                                                disabled={!hasFile}
                                            >
                                                Voir
                                            </Button>
                                            <Button
                                                size="small"
                                                variant="text"
                                                color="primary"
                                                startIcon={<DownloadRounded />}
                                                component="a"
                                                href={fileUrl || "#"}
                                                target={isServerFile ? "_blank" : undefined}
                                                rel={isServerFile ? "noopener noreferrer" : undefined}
                                                download={downloadName}
                                                disabled={!hasFile}
                                            >
                                                Télécharger
                                            </Button>
                                            {isServerFile && isFileAdmin &&
                                                <IconButton
                                                    size="small"
                                                    color="secondary"
                                                    aria-label="Supprimer"
                                                    onClick={() => this.openDeleteAttachmentDialog(file.__serverFile)}
                                                >
                                                    <DeleteRounded fontSize="small" />
                                                </IconButton>
                                            }
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Paper>
                    </Grid>



                    <Grid item container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                onChange={this.handleChange}
                                type="number"
                                name="spending_TVA" 
                                id="spending_TVA" 
                                value={this.state.spending_TVA} 
                                label="TVA" 
                                error={this.state.errors.spending_amountTTC}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputText
                                onChange={this.handleChange}
                                type="number"
                                name="spending_taxes" 
                                id="spending_taxes" 
                                value={this.state.spending_taxes} 
                                label="Autres Taxes (Crédit)" 
                                error={this.state.errors.spending_amountTTC}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputText
                                onChange={this.handleChange}
                                type="number"
                                name="spending_taxes_debit" 
                                id="spending_taxes_debit" 
                                value={this.state.spending_taxes_debit} 
                                label="Autres Taxes (Debit)" 
                                error={this.state.errors.spending_amountTTC}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={6}>
                            <Creatable
                                label="Catégorie"
                                required={this.state.spending_status === "VALIDATE"}
                                error={this.state.errors.spending_category}
                                id="spending_category"
                                options={Object.values(CATEGORIES.CHILD).filter(c => c.is_active !== false).map( item => ({
                                    label: item.category_accounting_id ? `${item.category_accounting_id} - ${item.category_name}` : item.category_name,
                                    value: item.category_id
                                }))}
                                value={this.state.spending_categoryDisplay}
                                openPopUp={this.props.createNewCategory}
                                onChange={this.handleChangeCat}
                                // {...this.props}
                            />
                        </Grid>  
                                    
                        <Grid item xs={12} sm={6}>
                            <InputSelectNative 
                                label="Statut"
                                value={this.state.spending_status}
                                error={this.state.errors.spending_status}
                                onChange={this.handleChange}
                                required
                                disabled={this.props.spending && this.props.spending.spending_total_payed > 0 }
                                labelWidth={60} 
                                name="spending_status" 
                                id="spending_status"
                                options={[
                                    <option value="VALIDATE" >Validé</option>,
                                    <option value="WAITING_UPDATE" >Demande de Correction</option>,
                                    <option value="REFUSED" >Refusé</option>
                                ]}
                            />
                            
                        </Grid>
                        {this.state.spending_status === "VALIDATE" &&

                        <Fragment>
                            <Grid item xs={12} sm={6}>
                                <Creatable
                                    label="Fournisseur"
                                    required
                                    error={this.state.errors.spending_supplier}
                                    id="spending_supplier"
                                    labelWidth={100} 
                                    options={Object.values(SUPPLIERS).map( item => ({
                                        label: item.supplier_name,
                                        value: item.supplier_id
                                    }))}
                                    value={this.state.spending_supplierDisplay}
                                    openPopUp={this.props.createNewSupplier}
                                    onChange={(e) => this.handleChangeSelect(e, "spending_supplier")}
                                />
                            </Grid>

                            
                            <Grid item xs={12} sm={6}>
                                <InputSelectMultiV2
                                    label="Labels"
                                    id="spending_labels"
                                    options={Object.values(LABELS).map( item => ({
                                        label: item.label_name,
                                        value: item.label_id,
                                        disabled: Array.isArray(this.state.spending_labels) && !!this.state.spending_labels.find(element => element.value === item.label_id)
                                    }))}
                                    value={this.state.spending_labels}
                                    onChange={(option) => this.handleChangeMulti(option, "spending_labels")}
                                    isMulti
                                    withCheckBox
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputSelectMultiV2
                                    label="Projets"
                                    id="spending_project"
                                    options={Object.values(PROJECTS).map( item => ({
                                        label: item?.project_name || 'NA',
                                        value: item.project_id,
                                        disabled: Array.isArray(this.state.spending_project) && !!this.state.spending_project.find(element => element.value === item.project_id)
                                    }))}
                                    value={this.state.spending_project}
                                    onChange={(option) => this.handleChangeMulti(option, "spending_project")}
                                    isMulti
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {/* {!this.state.spending_chantier ? */}
                                    <InputText
                                        // onChange={this.handleChange}
                                        name="spending_chantier" 
                                        id="spending_chantier" 
                                        // value={this.state.spending_chantier_part} 
                                        label="Chantier"
                                        placeholder={size(this.state.spending_chantier_part)> 0 ? " " : ""}
                                        // options={[]}
                                        // onClick={ () => this.setState({ openChantierPopUp: true })} 
                                        startAdornment={size(this.state.spending_chantier_part)> 0 && this.state.spending_chantier_part.map((item, index) => (
                                            <Chip
                                                key={item.boxAssoId}
                                                tabIndex={-1}
                                                label={item.chantier_name}
                                                style={{margin: "1px"}}
                                                // className={classes.chip}
                                                onDelete={() => this.handleDeleteChip(index)}
                                            />
                                        ))
                                        }
                                        endAction={
                                            <IconButton
                                                aria-label="add chantier"
                                                onClick={() => this.setState({ openChantierPopUp: true })}
                                                // onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                                color="primary"
                                            >
                                                <AddCircleRounded />
                                            </IconButton>
                                            
                                        }
                                    />                                
                            </Grid>
                            {/* {!isEmpty(this.state.spending_equipement) &&
                                <Grid item xs={12} sm={6}>
                                    <InputText
                                        // onChange={this.handleChange}
                                        name="spending_equipement" 
                                        id="spending_equipement" 
                                        // value={this.state.spending_equipement_part} 
                                        label="Equipement"
                                        placeholder={size(this.state.spending_equipement_part)> 0 ? " " : ""}
                                        // options={[]}
                                        // onClick={ () => this.setState({ openChantierPopUp: true })} 
                                        startAdornment={size(this.state.spending_equipement_part)> 0 && this.state.spending_equipement_part.map((item, index) => (
                                            <Chip
                                                key={item.equipement_id}
                                                tabIndex={-1}
                                                label={item.equipement_idDisplay.label}
                                                style={{margin: "1px"}}
                                                // className={classes.chip}
                                                onDelete={() => this.handleDeleteChipE(index)}
                                            />
                                        ))
                                        }
                                        endAction={
                                            <IconButton
                                                aria-label="add equipement"
                                                onClick={() => this.setState({ openOther: true })}
                                                // onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                                color="primary"
                                            >
                                                <AddCircleRounded />
                                            </IconButton>
                                            
                                        }
                                    />                                
                                </Grid>
                            } */}
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <Button onClick={() => this.setState({ openOther: true})}>Autres infos</Button>

                                </Box>
                            </Grid>
                        </Fragment>
                        }
                       
                        <Grid item xs={12}>
                            <TextArea
                                onChange={this.handleChange}
                                rows={this.state.spending_status !== "VALIDATE" ? 4 : 2}
                                required={false}
                                name="spending_remarks" 
                                id="spending_remarks" 
                                value={this.state.spending_remarks} 
                                label="Remarques" 
                                error={this.state.errors.spending_remarks}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                options={spendingDemandOptions}
                                value={this.getSpendingDemandOptionById(this.state.spending_demand, spendingDemandOptions)}
                                onChange={this.handleChangeSpendingDemand}
                                getOptionLabel={(option) => {
                                    const label = this.getSpendingDemandDisplay(option);
                                    return typeof label === 'string' ? label : '';
                                }}
                                isOptionEqualToValue={(option, value) =>
                                    option && value ? option.spending_demand_id === value.spending_demand_id : option === value
                                }
                                filterOptions={this.filterSpendingDemandOptions}
                                noOptionsText={isFetchingSpendingDemands ? "Chargement..." : "Aucune demande correspondante"}
                                loading={isFetchingSpendingDemands}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Demande de dépense"
                                        variant="outlined"
                                        helperText="Champ optionnel"
                                    />
                                )}
                                clearOnBlur={false}
                                handleHomeEndKeys
                            />
                        </Grid>
                    </Grid>                                     
                </Grid>
                <MuiDialog
                    open={this.state.previewAttachmentOpen}
                    onClose={this.closeAttachmentPreview}
                    maxWidth="md"
                    fullWidth
                >
                    <MuiDialogTitle>
                        {this.state.previewAttachmentIndex >= 0
                            ? `Justificatif ${this.state.previewAttachmentIndex + 1}`
                            : "Justificatif"}
                    </MuiDialogTitle>
                    <MuiDialogContent dividers>
                        {this.state.previewAttachmentLoading && (
                            <Typography variant="body2">Chargement du justificatif...</Typography>
                        )}
                        {this.state.previewAttachmentNotFound && (
                            <Typography variant="body2" color="error">
                                Justificatif introuvable.
                            </Typography>
                        )}
                        {!this.state.previewAttachmentLoading &&
                            !this.state.previewAttachmentNotFound &&
                            this.isPdfFile(this.state.previewAttachment) &&
                            previewAttachmentUrl && (
                            <embed
                                src={previewAttachmentUrl}
                                width="100%"
                                height="600px"
                                title={`justificatif-${this.state.previewAttachmentIndex + 1}`}
                                type="application/pdf"
                            />
                        )}
                        {!this.state.previewAttachmentLoading &&
                            !this.state.previewAttachmentNotFound &&
                            this.isImageFile(this.state.previewAttachment) &&
                            previewAttachmentUrl && (
                            <img
                                src={previewAttachmentUrl}
                                alt={`justificatif-${this.state.previewAttachmentIndex + 1}`}
                                style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }}
                            />
                        )}
                        {!this.state.previewAttachmentLoading &&
                            !this.state.previewAttachmentNotFound &&
                            !this.isPdfFile(this.state.previewAttachment) &&
                            !this.isImageFile(this.state.previewAttachment) && (
                            <Typography variant="body2">
                                Prévisualisation indisponible pour ce type de fichier.
                            </Typography>
                        )}
                    </MuiDialogContent>
                    <MuiDialogActions>
                        {previewAttachmentDownloadUrl && !this.state.previewAttachmentNotFound && (
                            <Button
                                color="primary"
                                component="a"
                                href={previewAttachmentDownloadUrl}
                                download
                                startIcon={<DownloadRounded />}
                            >
                                Télécharger
                            </Button>
                        )}
                        <Button onClick={this.closeAttachmentPreview} color="primary">
                            Fermer
                        </Button>
                    </MuiDialogActions>
                </MuiDialog>
                {this.state.deleteAttachmentDialog.open && (
                    <DeleteDialog
                        open={true}
                        close={this.closeDeleteAttachmentDialog}
                        title="la pièce justificative"
                        text={`Voulez-vous vraiment supprimer "${this.state.deleteAttachmentDialog.file && this.state.deleteAttachmentDialog.file.spf_file_name}" ?`}
                        validateBackend
                        externalError={this.state.deleteAttachmentError}
                        disabledSubmit={this.state.deletingAttachment}
                        handleSubmit={this.handleDeleteAttachmentSubmit}
                    />
                )}
            </Dialog>

        )
    }
}

// role is read from the connected auth store so the "Pièces justificatives"
// delete button can be gated on the back-office admin allowlist (COMPTA-220)
// without relying on every parent screen to pass it down explicitly.
const mapStateToProps = (state) => ({
    role: state.auth && state.auth.user && state.auth.user.role,
});

export default connect(mapStateToProps)(SpendingsUpdate);